
<template>
  <div class="appDashboard dashboard1">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>

    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="xs12 md12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout row wrap class="ml-3">
            <template v-if="type == 1">
              <v-flex xs12 md3 style="height: 50px; line-height: 50px;">
                <span>{{ $t("BatteryPackList.ContractorID") }}:</span><span class="nameStyle">{{currentContractorCd}}</span>
              </v-flex>
              <v-flex xs12 md3 style="height: 50px; line-height: 50px;">
                <span>{{ $t("BatteryPackList.ContractorName") }}:</span><span class="nameStyle">{{currentContractorNm}}</span>
              </v-flex>
              <v-flex xs12 offset-md3 md3 pr-3 style="text-align: right;">
                <v-btn depressed color="primary" v-on:click="onClickCurrentStatus" >{{ $t('CurrentStatus.Item')}}</v-btn>
                <v-btn depressed color="primary" v-on:click="onClickMap">{{ $t('Map.Item')}}</v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 md3 style="height: 50px; line-height: 50px;">
                <span>{{ $t("BatteryPackList.UserID") }}:</span><span class="nameStyle">{{currentUserCd}}</span>
              </v-flex>
              <v-flex xs12 md3 style="height: 50px; line-height: 50px;">
                <span>{{ $t("BatteryPackList.UserName") }}:</span><span class="nameStyle">{{currentUserNm}}</span>
              </v-flex>
              <v-flex xs12 md3 style="height: 50px; line-height: 50px;">
                <span>{{ $t("BatteryPackList.ContractorName") }}:</span><span class="nameStyle">{{currentContractorNm}}</span>
              </v-flex>
              <v-flex xs12 md3 pr-3 style="text-align: right;">
                <v-btn depressed color="primary" v-on:click="onClickCurrentStatus" >{{ $t('CurrentStatus.Item')}}</v-btn>
                <v-btn depressed color="primary" v-on:click="onClickMap">{{ $t('Map.Item')}}</v-btn>
              </v-flex>
            </template>
          </v-layout>

          <v-data-table :headers="headers" :items="records" v-model="selected" :pagination.sync="pagination" class="elevation-1" :loading="loading" item-key="serialNo">

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                  style="padding-left: 4px"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="onClickRow(props.item)">
                <td>
                  <v-checkbox primary hide-details v-model="props.item.selected"></v-checkbox>
                </td>
                <td class="text-xs-left">{{ props.item.serialNo }}</td>
                <td class="text-xs-left" :class="{ alarmError: props.item.alarmLevel>=3, alarmWarning: props.item.alarmLevel <= 2, alarmNothing: !props.item.alarmLevel }">●</td>
                <td class="text-xs-left">{{ props.item.userNm }}</td>
                <td class="text-xs-left">{{ props.item.capacity }}</td>
                <td class="text-xs-left">{{ props.item.soc }}</td>
                <td class="text-xs-left">{{ props.item.totalCurrent }}</td>
                <td class="text-xs-left">{{ props.item.totalVolt }}</td>
                <td class="text-xs-left">{{ props.item.onOffStatus }}</td>
                <td class="text-xs-left">{{ getStatus(props.item.chargeDischargeStatus) }}</td>
                <td class="text-xs-left">{{ props.item.maxCellVolt }}</td>
                <td class="text-xs-left">{{ props.item.minCellVolt }}</td>
                <td class="text-xs-left">{{ props.item.maxTemp }}</td>
                <td class="text-xs-left">{{ props.item.minTemp }}</td>
                <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.rentalUseTime }}</td>
                <!-- <td class="text-xs-left">{{ props.item.everyUseTime }}</td>
                <td class="text-xs-left">{{ props.item.lifeUseTime }}</td>
                <td class="text-xs-left">{{ props.item.lifeDischargeTime }}</td>
                <td class="text-xs-left">{{ props.item.lifeChargeTime }}</td>
                <td class="text-xs-left">{{ props.item.chargeVl }}</td>
                <td class="text-xs-left">{{ props.item.dischargeVl }}</td> -->
                <td class="text-xs-left">{{ props.item.vehicleTx }}</td>
                <td class="text-xs-left">{{ props.item.vehicleNo }}</td>
                <td class="text-xs-left">{{ props.item.svcstDt | moment }}</td>
                <td class="text-xs-left">{{ props.item.svcendDt | moment }}</td>
                <td class="text-xs-left">{{ props.item.gpsPosition }}</td>
                <td class="text-xs-left">{{ props.item.contactTx }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import echarts from "echarts";
import mediator from "../../components/common/mediator.vue";
import moment from "moment";

export default {
  name: "BatteryPackList",
  mixins: [mediator],
  mounted() {
    this.setHeaderName();
    this.updateView();
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      pagination: {
        sortBy: 'SerialNo'
      },
      selected: [],
      headers: [
        { text: "", sortable: false },
        { text: $t("BatteryPackList.Columns.SerialNo"), value:"serialNo" },
        { text: $t("BatteryPackList.Columns.AlarmLevel"), value:"alarmLevel" },
        { text: $t("BatteryPackList.Columns.UserNm"), value:"userNm" },
        { text: $t("BatteryPackList.Columns.Capacity"), value:"capacity" },
        { text: "SOC", value:"soc" },
        { text: $t("BatteryPackList.Columns.TotalCurrent"), value:"totalCurrent" },
        { text: $t("BatteryPackList.Columns.TotalVolt"), value:"totalVolt" },
        { text: $t("BatteryPackList.Columns.OnlineStatus"), value:"onOffStatus" },
        { text: $t("BatteryPackList.Columns.ChargeDischargeStatus"), value:"chargeDischargeStatus" },
        { text: $t("BatteryPackList.Columns.MaxCellVolt"), value:"maxCellVolt" },
        { text: $t("BatteryPackList.Columns.MinCellVolt"), value:"minCellVolt" },
        { text: $t("BatteryPackList.Columns.MaxTemp"), value:"maxTemp" },
        { text: $t("BatteryPackList.Columns.MinTemp"), value:"minTemp" },
        { text: $t("BatteryPackList.Columns.RentalUseTime"), value:"rentalUseTimeSec" },
        // { text: $t("BatteryPackList.Columns.EveryUseTime"), value:"everyUseTime" },
        // { text: $t("BatteryPackList.Columns.LifeUseTime"), value:"lifeUseTime" },
        // { text: $t("BatteryPackList.Columns.LifeDischargeTime"), value:"lifeDischargeTime" },
        // { text: $t("BatteryPackList.Columns.LifeChargeTime"), value:"lifeChargeTime" },
        // { text: $t("BatteryPackList.Columns.ChargeQuantityAmount"), value:"chargeVl" },
        // { text: $t("BatteryPackList.Columns.DischargeQuantityAmount"), value:"dischargeVl" },
        { text: $t("BatteryPackList.Columns.VehicleInfo"), value:"vehicleTx" },
        { text: $t("BatteryPackList.Columns.VehicleNo"), value:"vehicleNo" },
        { text: $t("BatteryPackList.Columns.RentalStartDate"), value:"svcstDt" },
        { text: $t("BatteryPackList.Columns.RentalEndDate"), value:"svcendDt" },
        { text: $t("BatteryPackList.Columns.GPSPosition"), value:"gpsPosition" },
        { text: $t("BatteryPackList.Columns.EmergencyContact"), value:"contactTx" }
      ],
      records: [],
      title: $t("BatteryPackList.Item"),
      name: this.$root.name,
      type: this.$root.type,
      assign: this.$root.assign,
      loading: true,
      currentUserCd: '',
      currentUserNm: '',
      currentContractorCd: '',
      currentContractorNm: '',
    };
  },
  methods: {
    onClickCurrentStatus() {
      const serialNo = this.publisher("GetSelectSerial", []);
      if(serialNo) {
        this.$router.push("/main_menu/current_status");
      } else {
        const $t = this.$t.bind(this);
        this.$swal($t("BatteryPackList.Message.NoSelect"))
      }
    },
    onClickMap() {
      const serialNo = this.publisher("GetSelectSerial", []);
      if(serialNo) {
        this.$router.push("/main_menu/map");
      } else {
        const $t = this.$t.bind(this);
        this.$swal($t("BatteryPackList.Message.NoSelect"))
      }
    },
    onClickRow(selectedItem) {
      this.records.forEach(item => {
        item.selected = false;
      });

      selectedItem.selected = true;

      this.publisher("SetSelectSerial", [selectedItem.serialNo]);
    },
    getStatus(value) {
      let status;

      // 多言語化対応
      const $t = this.$t.bind(this);
      switch (value) {
        case 0:
          value = $t("BatteryPackList.Columns.NoChargeStarus");
          break;
        case 1:
          value = $t("BatteryPackList.Columns.FastChargeStarus");
          break;
        case 2:
          value = $t("BatteryPackList.Columns.SlowChargeStarus");
          break;
        case 3:
          value = $t("BatteryPackList.Columns.HeatChargeStarus");
          break;
      }

      return value;
    },
    setHeaderName() {
      let vm = this;
      vm.axios
        .get(`${vm.$root.url}/Customer/BatteryPacklistHeader`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            type: vm.$root.type,
            assign: vm.$root.assign
          }
        })
        .then(response => {
          if(vm.$root.type == 1) {
            vm.currentContractorNm = response.data.contractorNm;
            vm.currentContractorCd = response.data.contractorCd;
          } else {
            vm.currentUserCd = response.data.userCd;
            vm.currentUserNm = response.data.userNm;
            vm.currentContractorNm = response.data.contractorNm;
          }
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    updateView() {
      let vm = this;
      vm.axios
        .get(`${vm.$root.url}/Customer/BatteryPacklist`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            type: vm.$root.type,
            assign: vm.$root.assign
          }
        })
        .then(response => {
          vm.records = response.data;
          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
          vm.loading = false;
        });
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    computedErrorLevel() {
      return alarmLevel > 2;
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("YYYY/MM/DD");
    }
  }
};
</script>

<style>
  .dashboard1 .offset-sm3 {
    margin: 0 !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
  .alarmError {
    color: red;
  }
  .alarmWarning {
    color: #cbcb00;
  }
  .alarmNothing {
    color: #00FF00;
  }
  .nameStyle {
    color: rgb(22, 135, 171);
    margin-left: 10px;
  }


  /* テーブルのヘッダーと先頭4列の固定用 */

  table{
    display:block;
    overflow:scroll;
    max-height: 80vh;
  }
  thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: white;
  }
  thead th:nth-child(1) {
    left: 0;
    z-index: 3;
  }
  thead th:nth-child(2) {
    left: 50px;
    z-index: 3;
  }
  thead th:nth-child(3) {
    left: 160px;
    z-index: 3;
  }
  thead th:nth-child(4) {
    left: 210px;
    z-index: 3;
  }
  tbody td{
    background-color: white;
  }
  tbody td:nth-child(1) {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    left: 0;
  }
  tbody td:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    left: 50px;
  }
  tbody td:nth-child(3) {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    left: 160px;
  }
  tbody td:nth-child(4) {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    left: 210px;
  }

</style>



// WEBPACK FOOTER //
// src/router/Customer/BatteryPackList.vue